import { Pipe, PipeTransform } from '@angular/core';
import { Contact } from '../../_services';

@Pipe({ name: 'contactFilterByActive' })
export class ContactActivePipe implements PipeTransform {
    transform(contacts: Contact[], deleted: boolean): any[] {
        if (!contacts) {
            return contacts;
        }

        return contacts.filter((contact) => contact.deleted === deleted);
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/contact-deleted.pipe.ts